import React from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

const QuoteModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] p-0 overflow-hidden">
        <DialogHeader className="p-6 pb-4 border-b">
          <div className="flex items-center justify-between">
            <DialogTitle className="text-2xl font-bold text-gray-900">
              Get a Repair Quote
            </DialogTitle>
            <button
              onClick={onClose}
              className="rounded-full p-2 hover:bg-gray-100 transition-colors"
              aria-label="Close"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        </DialogHeader>
        
        <div className="overflow-y-auto" style={{ maxHeight: 'calc(90vh - 100px)' }}>
          <iframe
            id="quoteform"
            src="https://www.myrepairapp.com/quoteform?api_key=CBouaRwnHEnZ2mI-h7f5r&bg_color=null&text_color=null&disabled_categories=&hide_schedule_step=false&hide_create_quote=false&country=US"
            style={{ border: 0, outline: 'none', display: 'block' }}
            frameBorder="0"
            width="100%"
            height="600"
            title="Repair Quote Form"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuoteModal;